var doResolve;
export var bootstrapPromise = new Promise(function (resolve) { return (doResolve = resolve); });
export function initializeComponentContext(context) {
    doResolve(context);
}
//# sourceMappingURL=bootstrapper.js.map